import { styled } from 'linaria/react';
import MaxWidth from '../Layout/MaxWidth';
import { theme } from '../Theme';

const Container = styled(MaxWidth)`
  padding: 0px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
  background: white;

  &.wide {
    background: #f3f3f3;
    max-width: 100%;
    padding: 20px 30px 30px 30px;
    ${theme.below.lg} {
      flex-direction: column;
    }
  }

  &.wide-PDP {
    justify-content: space-between;
    background: #f3f3f3;
    max-width: 100%;
    padding: 20px 30px 30px 30px;
    ${theme.below.lg} {
      flex-direction: column;
      padding: 0;
    }
  }
`;
export { Container };
